const GroupTabs = ({ activeTab, onTabChange, children, onMenuClick }) => {
  return (
    <div className="groupskg-group-tabs">
      <div className="groupskg-tabs-actions">
        <ul className="groupskg-nav groupskg-nav-tabs groupskg-small" role="tablist">
          <li className="groupskg-nav-item" role="presentation">
            <button
              className={`groupskg-nav-link ${activeTab === 'kids' ? 'groupskg-active' : ''}`}
              onClick={() => onTabChange('kids')}
            >
              Діти в групі
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === 'kids_left' ? 'groupskg-active' : ''}`}
              onClick={() => onTabChange('kids_left')}
            >
              Діти, що вибути з групи
            </button>
          </li>
        </ul>
        <div className="groupskg-right-links">
          <a href="#" onClick={(e)=>{ e.preventDefault(); onTabChange('tarifs') }}>Тарифи</a>
          {false && <a href="#" onClick={(e)=>{ e.preventDefault(); onMenuClick && onMenuClick() }}>Меню</a>}
        </div>
      </div>
      
      <div className="groupskg-tab-content">
        {children}
      </div>
    </div>
  );
};

export default GroupTabs;